module.exports = __webpack_public_path__ + "img/download.7da4a569.svg";